import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { US_STATE_CODES } from '../constants/us-states';

export const isStateCodeGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    const firstSegment = segments[0]?.path?.toLowerCase() ?? '';
    return US_STATE_CODES.has(firstSegment);
};
